module.exports = __webpack_public_path__ + "img/menu.576e8d9c.png";